export const Error404 = () => {
  return (
    <div className="example-inner">
      <span className="error-code">404</span> Not found
    </div>
  );
};
